import type { ApiV2PageReboundProductStrate } from '@dce-front/hodor-types/api/v2/page/dtos/strates/rebound_product/definitions';
import { Binder, type BinderProps } from '@dce-front/one-navigation';
import type { ResizeMode } from '@dce-front/onewebapp-utils';
import { ReboundProduct as SharedReboundProduct } from '@dce-front/sharedcomponent';
import Linker from '../../../../components/Linker/Linker';
import { useOnFocusable } from '../../../../helpers/hooks/useOnFocusable';
import type { FocusManager } from '../../../../helpers/oneNavigation/FocusManager';

type ReboundProductProps = {
  focusManager?: FocusManager;
  strate: ApiV2PageReboundProductStrate;
  resizeMode?: ResizeMode;
} & Pick<BinderProps, 'binderId' | 'middleware'>;

function ReboundProduct({
  strate,
  binderId,
  focusManager,
  middleware,
}: ReboundProductProps) {
  const [firstContent] = strate.contents || [];
  useOnFocusable(focusManager, !!strate.button);

  return (
    <Binder
      binderId={binderId}
      middleware={middleware}
      enabled={!!strate.button}
    >
      <SharedReboundProduct
        button={strate.button}
        title={firstContent?.title}
        urlLogo={firstContent?.URLLogo}
        altLogo={firstContent?.altLogo}
        trackingContext={strate.context}
        Linker={Linker}
      />
    </Binder>
  );
}

export default ReboundProduct;
